import { Button } from "@mui/material";
import { DynamicFormControl } from "../../../";
import ConfirmDialog from "../../helpers/confirm-dialog";
import { useState } from "react";

/** Button to cancel form entry */
function CancelButtonControl({ disabled, label, style, onCancel }: {
    disabled: boolean,
    label?: string,
    style?: any,
    onCancel: () => void
  }) {
    const [cancelOpen, setCancelOpen] = useState(false);

    return (
        <>
            <Button style={style} disabled={disabled} variant="outlined" onClick={() => setCancelOpen(true)}>{label ?? "Cancel"}</Button>

            <ConfirmDialog
                open={cancelOpen}
                onConfirm={() => { setCancelOpen(false); onCancel(); }}
                onDeny={() => setCancelOpen(false)}
                title="Cancel"
                message="Are you sure you would like to cancel? Any un-submitted entries will be lost."></ConfirmDialog>
        </>
    )
}


export default CancelButtonControl;